import * as React from 'react'
import { ROLE_NAME, USER_PORTAL_ROLES, ROLES, Title, Divider, DrawerModal, Loading } from 'prace-common-components'
import { $RoleContainer, $ModalContainer, $Container, $ArrowIcon } from './styles'
import Grid from '@material-ui/core/Grid'
import { EditRolesProps } from './types'
import { useLazyGetCallRolesQuery, useGetRoleListsQuery } from 'store/api/calls'
import { FlowCallCutoff } from 'store/api/calls/types'
import { EditCutoffRoleModal } from './EditCutoffRoleModal'
import { useGetCentersQuery } from 'store/api/partitions'

const roles = USER_PORTAL_ROLES.filter(
  (role) => ![ROLES.USER, ROLES.SUPER_ADMIN].includes(role))

export const EditRolesModal: React.FC<EditRolesProps> = ({ cutoffs, callId, onClose }) => {
  const [cutoffRoleOpen, setCutoffRoleOpen] = React.useState<ROLES | undefined>()
  const [callRoles, setCallRoles] = React.useState<{ cutoffRoles?: FlowCallCutoff }>({
    cutoffRoles: undefined,
  })
  const [rolesLoading, setRolesLoading] = React.useState(true)
  const { data, refetch, isLoading: roleListsLoading } = useGetRoleListsQuery({ callId: callId || 0 }, { skip: !callId})
  const [getCallRoles] = useLazyGetCallRolesQuery()
  const { data: centers = [], isLoading: centersLoading } = useGetCentersQuery()

  const roleLists = data?.cutoffLists || []
  const userGroups = data?.userGroups || []
  const allCutOffRoles = callRoles?.cutoffRoles

  React.useEffect(() => {
    const getRoles = async () => {
      try {
        if(!callId) return
        const callRoles = await getCallRoles({ callId }).unwrap()
        setCallRoles(callRoles)
      } catch (err) {
        console.log(err)
      } finally {
        setRolesLoading(false)
      }
    }
    getRoles().catch((err) => console.log(err))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCallRoles, callId])

  const getRoles = async () => {
    return await getCallRoles({ callId }).unwrap()
  }

  const handleClose = () => {
    //setCopyRolesOpen(false)
    setCutoffRoleOpen(undefined)
    //setOriginCutoff(null)
  }

  /* TODO: Hidden Feature for now */
  /* const handleCopyRoles = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const target = e.target as typeof e.target & {
      cutoff: { value: string },
    }

    if(!target.cutoff.value) return

    try {
      const otherRoleLists = await getCutOffRoleList({ callId, cutOffId: Number(target.cutoff.value) }).unwrap()
      const roles = (otherRoleLists?.cutoffLists || []).map((list) => ({
        role: list.role,
        userGroupId: list.usersGroupId ?? undefined,
      }))
      await updateCutOffRole({ id: selectedCutoffId, roles }).unwrap()
      await refetch()
      const callRoles = await getCallCutoffRoles({ callId, cutOffId: selectedCutoffId }).unwrap()
      setCallRoles(callRoles)
      handleClose()
      dispatch({ type: 'notification', payload: { type: NotificationType.success, msg: 'Roles Copied' } })
    } catch (err) {
      console.log(err)
    }

  } */

  const userGroupItems = userGroups?.map((group) => ({ label: group.name, value: group.id })) || []
  
  if(!cutoffs.length) return null

  const isLoading = rolesLoading || roleListsLoading || centersLoading

  /* Sort roles by number of users and then by name */
  const sortedRoles = allCutOffRoles ? [
    ROLES.APPLICANT,
    ...roles.filter((role) => (role !== ROLES.APPLICANT && 
      (allCutOffRoles?.[role]?.length || roleLists.find((list) => list.role === role)?.usersGroupId))
     || (role === ROLES.COMPUTE_CENTRE_REPRESENTATIVE)).sort(),
  ] : roles

  const unusedRoles = roles.filter((role) => !sortedRoles.includes(role)).sort()

  return <>
    <DrawerModal
      title='Call Roles'
      open
      handleClose={onClose}
    >
      <$ModalContainer>
        {isLoading ? <Loading /> : cutoffRoleOpen ?
          <EditCutoffRoleModal
            refetch={refetch}
            cutoffs={cutoffs}
            callId={callId}
            roleLists={roleLists}
            setCallRoles={setCallRoles}
            getCutOffRoles={getRoles}
            roles={sortedRoles}
            role={cutoffRoleOpen}
            userGroups={userGroups}
            allCutoffRoles={allCutOffRoles}
            handleClose={handleClose}
            userGroupItems={userGroupItems}
            centers={centers}
          /> :
          <>
            <$Container container justifyContent='space-between'>
              <Grid item>
                <Title noWrap noMargin>
                  Active Roles
                </Title>
              </Grid>
            </$Container>
            <$RoleContainer container>
              <Grid item xs={12}>
                {sortedRoles.map((role) => <div key={role}>
                  <Title subTitle noWrap noMargin
                    onClick={() => setCutoffRoleOpen(role)}
                    actionIcon={<$ArrowIcon name='chevron-right' color='#19317B' />}
                    onAction={() => setCutoffRoleOpen(role)}
                  >
                    {ROLE_NAME[role]}
                  </Title>
                  <Divider noMarginBottom={false} />
                </div>)}
              </Grid>
              <Grid item xs={12}>
                <Title noWrap noMargin>
                    Unused roles
                </Title>
              </Grid>
              <Grid item xs={12}>
                {unusedRoles.map((role) => <div key={role}>
                  <Title subTitle noWrap noMargin
                    onClick={() => setCutoffRoleOpen(role)}
                    actionIcon={<$ArrowIcon name='chevron-right' color='#19317B' />}
                    onAction={() => setCutoffRoleOpen(role)}
                  >
                    {ROLE_NAME[role]}
                  </Title>
                  <Divider noMarginBottom={false} />
                </div>)}
              </Grid>
            </$RoleContainer>
          </>}
      </$ModalContainer>
    </DrawerModal>
  </>
}
